import React, { Fragment, PureComponent } from 'react';
import { connect } from "react-redux";
import PropTypes from 'prop-types';
import "react-datepicker/dist/react-datepicker.css";
import MUIDataTable from "mui-datatables";
import { Table } from 'reactstrap';
import { Button } from 'reactstrap';
import IconButton from '@mui/material/IconButton';
import ConfirmationDialog from "Routes/common/ConfirmationDialog";

 // app config
import AppConfig from 'Constants/AppConfig';
// rct card box
import RctCollapsibleCard from 'Components/RctCollapsibleCard/RctCollapsibleCard';

import { CarouselProvider, Slider, Slide, ButtonBack, ButtonNext, Dot } from 'pure-react-carousel';
import 'pure-react-carousel/dist/react-carousel.es.css';

import { 
    fetchSamLabReport,
    fetchPlayerSamLab,
    deleteSamLabReport,
 } from 'Actions';

 import AddItem from '../../../technologyreport/samlabreport/component/addform';
 import EditForm from '../../../technologyreport/samlabreport/component/editform';

 import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
 import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
 import KeyboardDoubleArrowLeftIcon from '@mui/icons-material/KeyboardDoubleArrowLeft';

class SamItems extends React.Component {
  
    static propTypes = {
        classes: PropTypes.object,
        prev:0,

    };

    UNSAFE_componentWillMount() {
	}
    constructor(props) {
      
        super(props);
        this.nodeRef = React.createRef();
        this.confirmationDialog = React.createRef();
        this.state = {  
            student: this.props.data.student, 
            startdate:this.props.data.startdate,
            enddate:this.props.data.enddate,            
            heightProportion: 1600,
            widthProportion: 500,
            listdiv:true,
            reportdiv:false,
            adddiv:false,
            editdiv:false,
            alllstdiv1:false,
            frmreport:this.props.data.frmreport, 
            
        };

        this.onPrevSection = this.onPrevSection.bind(this); 
        this.onBacksection = this.onBacksection.bind(this); 
        this.onAddSession = this.onAddSession.bind(this);
        this.onListSession = this.onListSession.bind(this); 
        this.deleteForm = this.deleteForm.bind(this); 
    }

    editAssessment(gid){
        this.props.fetchSamLabReport(gid).then((data) => {   
            var resdata=data.data;           

            this.setState({ 
                listdiv:false, 
                alllstdiv1:false,
                reportdiv:true,
            });

        });
    }

    onPrevSection(){

        var student=this.state.student;
        var stdate=this.state.startdate;
        var eddate=this.state.enddate;
        this.props.fetchPlayerSamLab(student, stdate, eddate);
        this.setState({
            reportdiv:false,
            alllstdiv1:false,
            adddiv:false,
            listdiv:true, 
        }); 
    }

    onAddSession(e, id) {
        e.preventDefault();
		this.setState({ 
         selfrom:id,
         listdiv:false,
         adddiv:true,
      });
    }
    
    onListSession(e, id) {
        e.preventDefault();
        if(id==1){
            var sellst='alllstdiv1';
        }

		this.setState({ 
         sellst:id,   
         [sellst]:true,   
         listdiv:false,
         adddiv:false,
      });
    }

    onBacksection(){
        var student=this.state.student;
        var stdate=this.state.startdate;
        var eddate=this.state.enddate;
        this.props.fetchPlayerSamLab(student, stdate, eddate);

        this.setState({ 
            alllstdiv1:false,  
            editdiv:false,
            adddiv:false,
            reportdiv:false,
            listdiv:true
        });
    }

    editAssessment2(gid) {
        this.props.fetchSamLabReport(gid).then((data) => {
           var resdata = data.data;  
           this.setState({
              viewdiv: false,
              adddiv: false,
              alllstdiv1:false,      
              editdiv: true,
           });
  
        });
     }
  
     deleteForm(data) {
        this.data = data;
        this.student=this.state.student;
        this.confirmationDialog.current.openDialog();
     }
  
     deleteDataPermanent(popupResponse) {
  
        if (popupResponse) {
           this.props.deleteSamLabReport(this.data);
           var student=this.student;
           this.props.fetchPlayerSamLab(student, '', '');
        }
     }



render() {
    const { playertechsamlab, particularsamlabreport, samlabreportlist, loading} = this.props; 
    const stdrole = localStorage.getItem('stdrole');
    const options = {
        filterType: 'dropdown',
        rowsPerPage: 50,
        rowsPerPageOptions: [50, 100, 150],
        selectableRowsHideCheckboxes: true,
    };

    const columns = [
        { name: "no", label: "NO" },
        { name: "name", label: "NAME" },
        { name: "cdate", label: "DATE" },
        { name: "action1", label: "ACTION1" },

     ];
    const tabledata = Array.isArray(playertechsamlab) ? playertechsamlab.map((assmntval, idx) => {
        
        const editBtn = (
           <IconButton className="text-info" aria-label="edit" onClick={() => this.editAssessment2(assmntval.tsrID)}><EditOutlinedIcon/></IconButton>
        );
        const deleteBtn = (
           <IconButton
              className="text-danger"
              aria-label="Remove"
              onClick={() => this.deleteForm(assmntval.tsrID)}
           >
              <DeleteOutlineOutlinedIcon/>
           </IconButton>
        );
        return {
           no: idx + 1,
           name: assmntval.student,
           cdate: assmntval.cdate,          
           action1: (
              <div>
                 {editBtn} {deleteBtn}
              </div>
           ),

        }
     }) : [];
     
    if(particularsamlabreport.length==0){
        var exfiles=[];
        var filecnt=0; 
    }else{
        const allfile=particularsamlabreport.tsr_filename;        
        if(allfile==''){
            var exfiles=[];
            var filecnt=0;
        }else{
            var exfiles=allfile.split(',');
            var filecnt=exfiles.length;
        }
    }

    const styles = {
        subheading: {
            fontWeight:"bold"
        }

    }  

      return(
            <div>
                <div className="col-md-12 col-lg-12 col-sm-12">
                    <h1 className="text-center" style={{padding:"20px"}}> SAM LAB SESSION</h1>
                </div>
                

                {this.state.listdiv && 
                    <>
                    <div className="col-md-12 col-lg-12 col-sm-12" style={{marginBottom:"10px"}}>
                        <div className="ddd">
                            <div className="float-right"><Button onClick={this.props.onClick} className="btn btn-outline-warning"><KeyboardDoubleArrowLeftIcon aria-hidden="true" />  Back To Technology</Button></div>
                            
                        </div>
                    </div>
                    <div className="col-sm-12 col-lg-10" style={{margin:"0 auto"}}>
                            
                            <RctCollapsibleCard heading="Report" chkbtn={stdrole==1? 0 :1 } addbtn onClickAdd={e => this.onAddSession(e, 1)} listbtn onClickList={e => this.onListSession(e, 1)}  fullBlock>
                            <div className="table-responsive reporttable">
                                <Table hover bordered striped>
                                    <thead>
                                        <tr className="bg-info text-white">
                                            <th>NO</th>
                                            <th>NAME</th>
                                            <th>DATE</th>
                                            <th>REPORT</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {playertechsamlab.map((assmntval,idx) => {
                                            return (
                                                <tr>
                                                    <td>{idx+1}</td>
                                                    <td>{assmntval.student}</td>
                                                    <td>{assmntval.cdate}</td>
                                                    <td><a onClick={ ()=>this.editAssessment(assmntval.tsrID)}><span className="badge badge-info" >View</span></a></td>                                                    
                                                </tr>
                                            );
                                        })}
                                    </tbody>
                                </Table> 
                            </div>    
                        </RctCollapsibleCard>
                    </div>
                    </>
                }
                {this.state.reportdiv && 
                <div className="col-md-12">
                    <div className="row">
                        <div className="col-sm-12 col-md-4">
                            <RctCollapsibleCard heading="SAM LAB DETAILS">
                                <div className="float-right">
                                    <button type="button" className="mr-10 mb-10 btn btn-outline-warning " onClick={this.onPrevSection}>Back</button> 
                                </div> 
                                <div className="table-responsive">
                                    <Table hover bordered striped>
                                        
                                        <tbody>                              
                                        
                                            <tr>
                                                <td>STUDENT</td>
                                                <td style={styles.subheading}> {particularsamlabreport.student} </td>
                                            </tr>
                                            <tr>
                                                <td>DATE</td>
                                                <td style={styles.subheading}> {particularsamlabreport.cdate} </td>
                                            </tr>
                                            <tr>
                                                <td>SETUP</td>
                                                <td style={styles.subheading}>{particularsamlabreport.tsr_setup==0 ? "" :  particularsamlabreport.tsr_setup} </td>
                                            </tr>
                                            <tr>
                                                <td>AIM PERCEPTION</td>
                                                <td style={styles.subheading}>{particularsamlabreport.tsr_aimperception==0 ? "" :  particularsamlabreport.tsr_aimperception} </td>
                                            </tr>
                                            <tr>
                                                <td>AIM</td>
                                                <td style={styles.subheading}>{particularsamlabreport.tsr_aim==0 ? "" :  particularsamlabreport.tsr_aim} </td>
                                            </tr>
                                            <tr>
                                                <td>FACE AT IMPACT</td>
                                                <td style={styles.subheading}>{particularsamlabreport.tsr_faceimpact==0 ? "" :  particularsamlabreport.tsr_faceimpact} </td>
                                            </tr>
                                            <tr>
                                                <td>PATH</td>
                                                <td style={styles.subheading}>{particularsamlabreport.tsr_path==0 ? "" :  particularsamlabreport.tsr_path} </td>
                                            </tr>
                                            <tr>
                                                <td>CONTACT</td>
                                                <td style={styles.subheading}>{particularsamlabreport.tsr_contact==0 ? "" :  particularsamlabreport.tsr_contact} </td>
                                            </tr>
                                            <tr>
                                                <td>LAUNCH</td>
                                                <td style={styles.subheading}>{particularsamlabreport.tsr_launch==0 ? "" :  particularsamlabreport.tsr_launch} </td>
                                            </tr>
                                            <tr>
                                                <td>ACCELERATION PROFILE</td>
                                                <td style={styles.subheading}>{particularsamlabreport.tsr_acceleration==0 ? "" :  particularsamlabreport.tsr_acceleration} </td>
                                            </tr>
                                            <tr>
                                                <td>DRILLS</td>
                                                <td style={styles.subheading}>{particularsamlabreport.tsr_drills==0 ? "" :  particularsamlabreport.tsr_drills} </td>
                                            </tr>
                                            <tr>
                                                <td>REPORT NAME</td>
                                                <td style={styles.subheading}>{particularsamlabreport.tsr_reportname==0 ? "" :  particularsamlabreport.tsr_reportname} </td>
                                            </tr>

                                                                
                                        </tbody>
                                    </Table>
                                </div>   
                            </RctCollapsibleCard>
                        </div> 
                         <div className="col-sm-12 col-md-8" ref={this.nodeRef}>
                            <CarouselProvider                            
                                naturalSlideWidth={this.state.widthProportion}
                                naturalSlideHeight={this.state.heightProportion}
                                totalSlides={filecnt}
                            >
                            <div className="sdfsdf">
                                <div className="text-center" style={{marginTop:"-30px"}}>
                                    {exfiles.map((uptval,idx) => ( 
                                        <Dot className="text-center" slide={idx} >{idx+1}</Dot>
                                    ))}
                                </div>                        
                            </div>
                            <Slider>
                            {exfiles.map((uptval,idx) => (                                  
                                    <Slide index={idx}> 
                                      <RctCollapsibleCard>
                                        <iframe src={AppConfig.apiurl+'/theme/img/samlab/'+uptval} width="100%" height={600} ></iframe>
                                      </RctCollapsibleCard>
                                    </Slide>
                            ))}        
                            </Slider>
                            </CarouselProvider>    
                         </div>


                    </div>
                </div>
                }

                {this.state.alllstdiv1 &&
                    <div className="col-sm-12 col-lg-10" style={{margin:"0 auto"}}>
                        <RctCollapsibleCard heading="List" backtoadd onClick={this.onPrevSection} fullBlock>
                            <MUIDataTable
                                data={tabledata}
                                columns={columns}
                                options={options}
                            />
                        </RctCollapsibleCard>
                    </div>
                }

                {this.state.adddiv &&
                   <AddItem onClick={this.onPrevSection} data={this.state}/> 
                }

                {this.state.editdiv &&
                    <EditForm onClick={this.onBacksection} data={this.state}/>
                }

                <ConfirmationDialog
                ref={this.confirmationDialog}
                onConfirm={(res) => this.deleteDataPermanent(res)}
                data={'sam lab report'}
                />
            </div>

              
    )
   
}
 
}

const mapStateToProps = ({ playerintervention, samlabreport}) => {
   
    const { playertechsamlab, samlabreportlist, loading } = playerintervention;
    const { particularsamlabreport } = samlabreport;
    return { playertechsamlab, particularsamlabreport, samlabreportlist, loading };   
}


export default connect(mapStateToProps, {
    fetchSamLabReport,
    fetchPlayerSamLab,
    deleteSamLabReport,
})(SamItems);
